import { useEffect,useState } from "react";
import realtimeDB from "../Utils/api";

const useHorariosCarta = (firebaseId) =>
{
    const [Horarios, setHorarios] = useState(undefined);
    
    useEffect(() => 
    {
        realtimeDB.ref(`/HorariosCarta/${firebaseId}`).on("value",snapshot =>
        {
            let horarios = {};
            snapshot.forEach(horario =>
            {
                horarios[horario.key] = horario.val();
            });
            setHorarios(horarios);
        })
    }, []);

    return Horarios;
}

export default useHorariosCarta;